import { MessageBox } from 'element-ui'
import i18n from '@/i18n'
import { findTimeZoneLabel, formatTimeZoneLabel } from '@/constants/timeZones'
import { getBrowserTimeZoneId, isAccountTimeZoneMatchingBrowser } from '@/utils/timezone'

/**
 * 登录后校验：本机时区与设定中的用户自定义时区不一致时弹窗提醒。
 */
export async function alertTimeZoneMismatchIfNeeded (accountZoneId) {
  if (accountZoneId == null || accountZoneId === '') {
    return
  }
  if (isAccountTimeZoneMatchingBrowser(accountZoneId)) {
    return
  }
  const browserZone = getBrowserTimeZoneId()
  const browserLabel = formatTimeZoneLabel(browserZone)
  const accountLabel = findTimeZoneLabel(accountZoneId)

  await MessageBox.alert(
    i18n.t('account.name50', { browser: browserLabel, account: accountLabel }),
    i18n.t('account.name49'),
    {
      confirmButtonText: i18n.t('public.name25'),
      type: 'warning',
    }
  )
}
